const styles = {
  wrap: { display: "inline-flex", alignItems: "center", gap: "6px" },
  dot: { width: "8px", height: "8px", borderRadius: "2px", flexShrink: 0 },
  select: {
    border: "1px solid transparent",
    borderRadius: "6px",
    padding: "3px 4px",
    fontSize: "12px",
    fontWeight: "600",
    color: "#374151",
    backgroundColor: "transparent",
    cursor: "pointer",
    fontFamily: "inherit",
    maxWidth: "140px",
  },
  selectHover: { borderColor: "#d1d5db", backgroundColor: "#ffffff" },
};

const SalesTagSelect = ({ tags, value, onChange, disabled = false, ariaLabel = "태그" }) => {
  const current = tags.find((t) => t.id === value);
  return (
    <span style={styles.wrap}>
      <span style={{ ...styles.dot, backgroundColor: current?.color || "#d1d5db" }} />
      <select
        aria-label={ariaLabel}
        style={styles.select}
        value={value ?? ""}
        disabled={disabled}
        onChange={(e) => onChange(Number(e.target.value))}
        onMouseEnter={(e) => Object.assign(e.currentTarget.style, styles.selectHover)}
        onMouseLeave={(e) => Object.assign(e.currentTarget.style, { borderColor: "transparent", backgroundColor: "transparent" })}
      >
        {!current && <option value="">선택</option>}
        {tags.map((t) => (
          <option key={t.id} value={t.id}>{t.name}</option>
        ))}
      </select>
    </span>
  );
};

export default SalesTagSelect;
